import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "./ResourceDetail.css";
import { getResource } from "../data/resourcesData";
import { useScrollToTopOnMount } from "../hooks/useScrollToTop";

export default function ResourceDetail() {
  const { type, id } = useParams(); // "case-studies" | "news"
  const navigate = useNavigate();

  useScrollToTopOnMount();

  const item = getResource(type, id);

  if (!item) {
    return (
      <main className="rd-page">
        <div className="rd-container rd-empty">
          <h1>Not found</h1>
          <p>This resource does not exist or was moved.</p>
          <Link className="rd-btn rd-btn-primary" to="/resources">Back to Resources</Link>
        </div>
      </main>
    );
  }

  function share() {
    const url = window.location.href;
    if (navigator.share) {
      navigator.share({ title: item.title, text: item.excerpt, url }).catch(() => {});
    } else {
      navigator.clipboard?.writeText(url)
        .then(() => alert("Link copied to clipboard"))
        .catch(() => window.prompt("Copy this link:", url));
    }
  }

  return (
    <main className="rd-page">
      <header className="rd-hero">
        <div className="rd-hero-bg" aria-hidden="true">
          <span className="blob b1" />
          <span className="blob b2" />
        </div>
        <div className="rd-container">
          <div className="rd-breadcrumb">
            <button className="rd-link" onClick={() => navigate(-1)}>&larr; Back</button>
            <span className="rd-sep">/</span>
            <Link className="rd-link" to="/resources">Resources</Link>
            <span className="rd-sep">/</span>
            <span className="rd-type">{type === "case-studies" ? "Case Study" : "News"}</span>
          </div>

          <h1 className="rd-title">{item.title}</h1>
          <div className="rd-meta">
            <span className="rd-date">{item.date}</span>
            <div className="rd-tags">
              {item.tags.map((t) => <span key={t} className="rd-tag">{t}</span>)}
            </div>
          </div>
        </div>
      </header>

      <section className="rd-section">
        <div className="rd-container">
          <div className="rd-hero-thumb">
            {item.img ? <img src={item.img} alt="" onError={(e)=> (e.currentTarget.style.display='none')}/> : null}
          </div>

          <article className="rd-article">
            {item.body?.map((p, i) => <p key={i}>{p}</p>)}
          </article>

          <div className="rd-actions">
            <Link className="rd-btn rd-btn-secondary" to="/resources">Back to Resources</Link>
            <button className="rd-btn rd-btn-primary" onClick={share}>
              <span className="shine" aria-hidden="true" />
              Share
            </button>
          </div>
        </div>
      </section>
    </main>
  );
}